import { Disclosure } from "@headlessui/react";
import { ChevronRight } from "@material-ui/icons";
import { useEffect, useState } from "react";
import MaterialTableEmp from "components/tables/MaterialTableEmp";
import { useGetAssociatedHierarchyById } from "../hooks/useGetAssociatedHierarchyById";
import ReactTooltip from "react-tooltip";
import { useHistory } from "react-router-dom";
import { EmployeeTabs } from "modules/EmployeeTab/EmployeeTab";
import { permissionsSelector } from "modules/Login/selectors/permissionSelector";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { PERMISSIONS } from "modules/PermissionsConstants";
import { mainSelectedTab } from "modules/CarrierAgreementMgmt/atoms";

const AssociatedHierarchy = ({ hierarchyData, onClickParentHierarchy }) => {
  const { data: associatedHierarchyData } = useGetAssociatedHierarchyById(
    hierarchyData?.hierarchyId
  );
  const [, setLoading] = useState(true);
  const setSelectedIndex = useSetRecoilState(mainSelectedTab);
  const history = useHistory();

  //#region Permissions
  const userPermissions = useRecoilValue(permissionsSelector);
  const employeeViewPermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_employee_view;

  useEffect(() => {
    let timer = setTimeout(() => setLoading(false), 5000);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  const onClickEmployee = (employeeId, data) => {
    const url = "/employeetab/employee";
    history.push({
      pathname: url,
      state: {
        hierarchyId: hierarchyData?.hierarchyId,
        employeeId: employeeId,
        actionToManager: "LeadershipRedirection",
      },
    });

    let userTabs = [
      {
        to: "",
      },
    ];
    [...EmployeeTabs].forEach((tabs) => {
      let temp = [...userPermissions].filter(
        (user) => user === tabs.permission
      );
      if (temp.length > 0) userTabs.push(tabs);
    });
    userTabs.shift();
    const index = userTabs.findIndex((c) => c.to === url);
    setSelectedIndex(index);
  };

  const employeeTitles = [
    { key: "District", value: "Team Manager" },
    { key: "State", value: "District Manager" },
    { key: "Market", value: "Director" },
    { key: "Business Unit", value: "Vice President" },
  ];

  const matchData = employeeTitles
    ?.filter((x) => x.key === hierarchyData?.hierarchyTypeName)
    ?.map((x) => x.value)[0];

  const materialColumns = [
    {
      title:
        hierarchyData?.hierarchyTypeName === "Team"
          ? "Employee Name"
          : "Hierarchy Name",
      field:
        hierarchyData?.hierarchyTypeName === "Team"
          ? "employeeName"
          : "hierarchyName",
      render: (rowdata) => {
        return (
          <>
            {hierarchyData?.hierarchyTypeName === "Team" ? (
              <div
                className="cursor-pointer"
                onClick={() => {
                  onClickEmployee(rowdata.employeeId, rowdata);
                }}
              >
                <span className="blueAndBold underline">
                  {rowdata.employeeName}
                </span>
              </div>
            ) : (
              <div
                className="cursor-pointer"
                onClick={() => {
                  onClickParentHierarchy(rowdata);
                }}
              >
                <span className="blueAndBold underline">
                  {rowdata.hierarchyName}
                </span>
              </div>
            )}
          </>
        );
      },
    },
    {
      title: "Hierarchy Type",
      field: "hierarchyTypeName",
      width: "10%",
      hidden: hierarchyData?.hierarchyTypeName === "Team" ? true : false,
    },
    {
      title: matchData,
      field: "employeeName",
      hidden: hierarchyData?.hierarchyTypeName === "Team" ? true : false,
      width: "10%",
      render: (rowdata) => {
        return (
          <div>
            <ReactTooltip place="right" effect="solid" type="info" />
            {userPermissions.includes(employeeViewPermission) ? (
              rowdata.employeeName !== "" ? (
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    onClickEmployee(rowdata.employeeId, rowdata);
                  }}
                >
                  <span className="blueAndBold underline">
                    {rowdata.employeeName}
                  </span>
                </div>
              ) : (
                rowdata.employeeName
              )
            ) : (
              <div
                data-tip={
                  "Contact your System Administrator to secure access to employee module."
                }
                className="cursor-pointer"
              >
                {rowdata.employeeName}
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "Title",
      field: "employeeTitle",
      hidden: hierarchyData?.hierarchyTypeName === "Team" ? false : true,
    },
    {
      title: "Employee Number",
      field: "employeeNumber",
    },
    {
      title: "Status",
      field: "isActive",
      hidden: hierarchyData?.hierarchyTypeName === "Team" ? true : false,
      render: (rowData) => {
        return <div>{rowData.isActive ? "Active" : "Inactive"}</div>;
      },
    },
  ];

  return (
    <Disclosure defaultOpen>
      {({ open }) => (
        <>
          <div className="m-2 bg-white rounded-lg box-shadow">
            <Disclosure.Button className="disclosureBtn ml-2">
              <ChevronRight
                className={`${
                  open ? "transform rotate-90" : " text-gray-500"
                } text-gray-500 w-5 h-5 `}
              />
              <span className="disclosureLabel ml-2">
                {hierarchyData?.hierarchyTypeName === "Team"
                  ? "Associated Frontline Employees"
                  : "Associated Hierarchy"}
              </span>
            </Disclosure.Button>
            <Disclosure.Panel className="text-xs  ">
              <div className="w-full p-2 bg-white">
                <div className="overflow-x-auto grid grid-row">
                  <MaterialTableEmp
                    data={associatedHierarchyData}
                    columns={materialColumns}
                    options={{
                      pageSize: 3,
                      toolbar: false,
                      showTitle: false,
                      exportButton: false,
                      search: true,
                      headerStyle: {},
                      rowStyle: {},
                    }}
                  />
                </div>
              </div>
            </Disclosure.Panel>
          </div>
        </>
      )}
    </Disclosure>
  );
};

export default AssociatedHierarchy;
